// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import store from './store'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faSpinner, faSadTear, faStars, faBullseyePointer } from '@fortawesome/pro-light-svg-icons'
import { faBullseyeArrow } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueCountdownTimer from 'vuejs-countdown-timer'
import VModal from 'vue-js-modal'
import flowplayer from 'flowplayer'
import hlsjs from 'flowplayer-hlsjs'
// import videojshlsjs from 'videojs/http-streaming'
import 'flowplayer/dist/skin/skin.css'
import 'video.js/dist/video-js.min.css'
import VueCountdown from '@chenfengyuan/vue-countdown'
import videojs from 'video.js'
hlsjs(flowplayer)
// videojshlsjs(videojs)
Object.defineProperty(Vue.prototype, '$flowplayer', { value: flowplayer })
Object.defineProperty(Vue.prototype, '$videojs', { value: videojs })
library.add(faCoffee, faSpinner, faSadTear, faStars, faBullseyeArrow, faBullseyePointer)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component(VueCountdown.name, VueCountdown)
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(require('vue-moment'))
Vue.use(VueCountdownTimer)
Vue.use(VModal)

Vue.config.productionTip = false

// Vue.prototype.$serviceAddress = 'http://localhost:3001/'
Vue.prototype.$serviceAddress = 'https://wordup.ankaradil.com/'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js